import { gql } from "@apollo/client";
const GET_CONSUMER = gql `
  query getConsumer {
    getConsumer {
      salesforceId
      firstName
      lastName
      email
      birthdate
      mobilePhone
      country
      countryCode
      city
      zipCode
      streetAddress
      language: preferredLanguage
      state
      additionalCustomerIds {
        id
        code
      }
      hasOptedOutOfEmail
      optInDate
      optOutDate
      customerType
      username
      gtmId
    }
  }
`;
export default GET_CONSUMER;
